<template>
    <div class="title">{{title}}</div>
</template>

<script>
import Constants from '../../constants';

export default {
    props: ['question', 'providerId', 'context', 'answer', 'index'],
    data() {
        return {
            id: this.question.id,
            content: this.question.content,
            Constants,
        };
    },

    computed: {
        title: function() {
            return this.content.meta.title || this.$t('form.section', {count: this.index + 1});
        },
    },
}
</script>

<style scoped lang="scss">
.outer {
    position: relative;
    text-align: center;
    margin: 12px 0;
}

.title {
    font-size: 1.3rem;
    font-weight: bold;
    display: block;
    padding: 24px 16px 4px;
    scroll-margin-top: 120px;
}
</style>
